import {
  handleConnect,
  handleConnectError,
  handleDisconnect,
} from "./receivers/connection";
import handlePost from "./receivers/handlePost";
import handleUpdate from "./receivers/handleUpdate";

const registerReceivers = (socket, dispatch) => {
  socket.on("connect", () => handleConnect(socket));
  socket.on("disconnect", handleDisconnect);
  socket.on("connect_error", handleConnectError);

  socket.on("add", handlePost(dispatch));
  socket.on("update", handleUpdate(dispatch));
};

export default registerReceivers;
